import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL  = 'https://uiuiwzqvrfzyrxydqubi.supabase.co';   // e.g. https://xyzxyz.supabase.co
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVpdWl3enF2cmZ6eXJ4eWRxdWJpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQyMzY5OTAsImV4cCI6MjA4OTgxMjk5MH0.fBjrcEjCeCyMgdl0lBaTIwc3axgyufBbGNi_zrck58Q';      // long string starting with eyJ...

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);
